/**
 * LINX EXPRESS — Translation dictionary.
 * FR (default) and AR.
 */

const translations = {
  // ─── NAVBAR ───
  'nav.features': { fr: 'Fonctionnalités', ar: 'الميزات' },
  'nav.howItWorks': { fr: 'Comment ça marche', ar: 'كيف يعمل' },
  'nav.app': { fr: "L'Application", ar: 'التطبيق' },
  'nav.faq': { fr: 'FAQ', ar: 'الأسئلة الشائعة' },
  'nav.reseller': { fr: 'Devenir revendeur', ar: 'كن موزعاً' },
  'nav.download': { fr: 'Télécharger', ar: 'تحميل' },
  'nav.downloadApp': { fr: "Télécharger l'App", ar: 'تحميل التطبيق' },
  'nav.close': { fr: 'Fermer', ar: 'إغلاق' },
  'nav.menu': { fr: 'Menu', ar: 'القائمة' },

  // ─── HERO ───
  'hero.headline': {
    fr: 'Le transport de demain en Tunisie',
    ar: 'نربطك بأفضل ناقل… في أسرع وقت',
  },
  'hero.subtitle': {
    fr: 'Connectez-vous avec des transporteurs vérifiés. Suivez chaque expédition en temps réel.',
    ar: 'تواصل مع ناقلين موثوقين. تتبع كل شحنة في الوقت الفعلي.',
  },
  'hero.finalHeadline': {
    fr: 'Prêt à simplifier vos transports ?',
    ar: 'هل أنت مستعد لتبسيط عمليات النقل؟',
  },
  'hero.finalSubtitle': {
    fr: 'Téléchargez LinxExpress et rejoignez la première plateforme digitale de transport en Tunisie.',
    ar: 'حمّل LinxExpress وانضم لأول منصة رقمية للنقل في تونس.',
  },
  'hero.cta': { fr: 'Découvrir LinxExpress', ar: 'اكتشف LinxExpress' },
  'hero.scroll': { fr: 'Scroll', ar: 'تمرير' },
  'hero.scrollDown': { fr: 'Défiler vers le bas', ar: 'التمرير للأسفل' },

  // ─── FEATURES ───
  'features.label': { fr: 'Fonctionnalités', ar: 'الميزات' },
  'features.heading': { fr: "Tout ce qu'il vous faut", ar: 'كل ما تحتاجه' },

  // Client features (image cards)
  'features.0.title': { fr: 'Tous types de transport', ar: 'جميع أنواع النقل' },
  'features.0.desc': {
    fr: 'Déménagement, mobilier, matériaux de construction, animaux et bien plus. Pour chaque besoin, un transporteur adapté disponible rapidement.',
    ar: 'نقل منازل، أثاث، مواد بناء، حيوانات والمزيد. لكل حاجة، ناقل مناسب متاح بسرعة.',
  },
  'features.1.title': { fr: 'Communication sécurisée', ar: 'تواصل آمن' },
  'features.1.desc': {
    fr: "Appelez et chattez avec votre transporteur directement depuis l'app. Votre numéro personnel n'est jamais partagé ni visible.",
    ar: 'تحدث ودردش مع الناقل مباشرة من التطبيق. رقمك الشخصي لا يُشارك أبداً ولا يظهر للناقل.',
  },
  'features.2.title': { fr: 'SOS Remorquage', ar: 'إنقاذ طارئ SOS' },
  'features.2.desc': {
    fr: 'Tombé en panne sur la route ? Le service SOS vous met en contact avec le remorqueur le plus proche pour une intervention rapide.',
    ar: 'تعطّلت سيارتك على الطريق؟ خدمة SOS تربطك بأقرب ناقل سحب للتدخل السريع.',
  },
  'features.3.title': {
    fr: "Location d'engins — Bientôt",
    ar: 'استئجار آليات — قريباً',
  },
  'features.3.desc': {
    fr: "Grue, pelleteuse, bulldozer, chargeuse… Louez des engins de chantier directement depuis l'application.",
    ar: 'رافعة، حفّارة، بلدوزر، شاحنة تحميل… استأجر آليات بناء مباشرة من التطبيق.',
  },
  'features.3.badge': { fr: 'Bientôt', ar: 'قريباً' },

  // Driver features (image cards)
  'features.4.title': { fr: 'Plus de missions', ar: 'مزيد من المهام' },
  'features.4.desc': {
    fr: 'Recevez des demandes de transport où que vous soyez en Tunisie. Ne manquez plus aucune opportunité.',
    ar: 'تلقَّ طلبات النقل أينما كنت في تونس. لا تفوّت أي فرصة.',
  },
  'features.5.title': { fr: 'Visibilité nationale', ar: 'حضور وطني' },
  'features.5.desc': {
    fr: 'Votre profil est accessible par des milliers de clients à travers tout le territoire tunisien.',
    ar: 'ملفك الشخصي متاح لآلاف العملاء في جميع أنحاء الأراضي التونسية.',
  },
  'features.6.title': { fr: 'Plus de bénéfices', ar: 'مزيد من الأرباح' },
  'features.6.desc': {
    fr: 'Optimisez vos revenus, renforcez votre réputation et accédez à de meilleures opportunités grâce au système de notation.',
    ar: 'حسّن إيراداتك، عزّز سمعتك وانفتح على فرص أفضل بفضل نظام التقييم.',
  },

  // ─── RESELLER FORM ───
  'reseller.label': { fr: 'Revendeurs', ar: 'الموزعون' },
  'reseller.heading': { fr: 'Devenez Point de Recharge', ar: 'كن نقطة شحن' },
  'reseller.desc': {
    fr: 'Rejoignez notre réseau de points de recharge LinxExpress et proposez à vos clients un service supplémentaire rentable.',
    ar: 'انضم إلى شبكة نقاط شحن LinxExpress وقدّم لعملائك خدمة إضافية مربحة.',
  },
  'reseller.firstName': { fr: 'Prénom', ar: 'الاسم الأول' },
  'reseller.lastName': { fr: 'Nom', ar: 'اللقب' },
  'reseller.company': { fr: 'Raison sociale', ar: 'الاسم التجاري' },
  'reseller.taxId': { fr: 'Matricule fiscale', ar: 'المعرّف الجبائي' },
  'reseller.email': { fr: 'Adresse e-mail', ar: 'البريد الإلكتروني' },
  'reseller.phone': { fr: 'Numéro de téléphone', ar: 'رقم الهاتف' },
  'reseller.address': { fr: 'Adresse complète', ar: 'العنوان الكامل' },
  'reseller.street': { fr: 'Rue', ar: 'الشارع' },
  'reseller.zip': { fr: 'Code postal', ar: 'الرمز البريدي' },
  'reseller.city': { fr: 'Gouvernorat', ar: 'الولاية' },
  'reseller.cityPlaceholder': {
    fr: 'Sélectionnez un gouvernorat',
    ar: 'اختر الولاية',
  },
  'reseller.submit': { fr: 'Envoyer ma candidature', ar: 'إرسال طلبي' },
  'reseller.submitting': { fr: 'Envoi en cours…', ar: 'جارٍ الإرسال…' },
  'reseller.success': {
    fr: 'Votre candidature a bien été envoyée. Nous vous contacterons dans les prochains jours.',
    ar: 'تم إرسال طلبك بنجاح. سنتواصل معك خلال الأيام القادمة.',
  },
  'reseller.error': {
    fr: 'Une erreur est survenue. Veuillez réessayer ou nous écrire à contact@agodevsolutions.com.',
    ar: 'حدث خطأ. الرجاء المحاولة مجدداً أو مراسلتنا على contact@agodevsolutions.com.',
  },

  // ─── ECOSYSTEM ───
  'bento.label': { fr: 'Écosystème', ar: 'النظام البيئي' },
  'bento.heading': { fr: 'Un réseau qui grandit', ar: 'شبكة في تنامٍ مستمر' },
  'bento.subtitle': {
    fr: 'LinxExpress connecte clients et transporteurs à travers toute la Tunisie avec une technologie fiable et rapide.',
    ar: 'LinxExpress يربط العملاء والناقلين في جميع أنحاء تونس بتكنولوجيا موثوقة وسريعة.',
  },
  'bento.badge.live': {
    fr: 'Actif dans 24 gouvernorats',
    ar: 'نشط في 24 ولاية',
  },
  'bento.badge.verified': { fr: '✓ Vérifiés', ar: '✓ موثّقون' },
  'bento.coverage.title': { fr: 'Couverture nationale', ar: 'تغطية وطنية' },
  'bento.coverage.desc': {
    fr: 'De Bizerte à Tataouine, notre réseau de transporteurs couvre les 24 gouvernorats tunisiens pour un service où que vous soyez.',
    ar: 'من بنزرت إلى تطاوين، شبكة ناقلينا تغطي الولايات الـ24 التونسية لخدمتك أينما كنت.',
  },
  'bento.drivers.title': { fr: 'Transporteurs vérifiés', ar: 'ناقلون موثّقون' },
  'bento.drivers.desc': {
    fr: 'Identité, permis, véhicule — chaque transporteur passe un processus de vérification complet avant de rejoindre la plateforme.',
    ar: 'هوية، رخصة، مركبة — كل ناقل يمر بعملية تحقق شاملة قبل الانضمام إلى المنصة.',
  },
  'bento.tech.title': {
    fr: 'Technologie intelligente',
    ar: 'تكنولوجيا ذكية',
  },
  'bento.tech.desc': {
    fr: 'GPS en temps réel, chat et appels intégrés, notifications push — tout pour une coordination parfaite.',
    ar: 'GPS فوري، دردشة واتصالات مدمجة، إشعارات فورية — كل ما تحتاجه لتنسيق مثالي.',
  },
  'bento.community.title': {
    fr: 'Une communauté en pleine croissance',
    ar: 'مجتمع في نمو مستمر',
  },
  'bento.community.desc': {
    fr: 'Des milliers de clients et transporteurs font déjà confiance à LinxExpress. Rejoignez un écosystème bâti sur la fiabilité et la rapidité.',
    ar: 'آلاف العملاء والناقلين يثقون بالفعل في LinxExpress. انضم إلى منظومة مبنية على الموثوقية والسرعة.',
  },
  'bento.stat.coverage': { fr: 'Gouvernorats', ar: 'ولاية' },
  'bento.stat.speed': { fr: 'Disponibilité', ar: 'التوافر' },
  'bento.stat.trust': { fr: 'Vérifiés', ar: 'موثّقون' },
  'bento.trust.title': { fr: 'Confiance vérifiée', ar: 'ثقة موثّقة' },
  'bento.trust.desc': {
    fr: 'Chaque transporteur passe un processus complet : identité, permis, véhicule et entretien de validation.',
    ar: 'يمر كل ناقل بعملية شاملة: هوية، رخصة، مركبة ومقابلة تحقق.',
  },
  'bento.speed.title': { fr: 'Rapidité garantie', ar: 'سرعة مضمونة' },
  'bento.speed.desc': {
    fr: 'Service disponible le jour même. Un transporteur prêt quand vous en avez besoin, partout en Tunisie.',
    ar: 'خدمة متاحة في نفس اليوم. ناقل جاهز عند حاجتك، في كل مكان في تونس.',
  },

  // ─── HOW IT WORKS ───
  'how.label': { fr: 'Comment ça marche', ar: 'كيف يعمل' },
  'how.heading': { fr: 'Du besoin à la livraison', ar: 'من الطلب إلى التسليم' },
  'how.step': { fr: 'Étape', ar: 'خطوة' },
  'how.0.title': { fr: 'Choisissez votre service', ar: 'اختر خدمتك' },
  'how.0.desc': {
    fr: 'Transport de marchandises ou dépannage SOS\u00a0? Sélectionnez le service adapté à votre situation en un clic.',
    ar: 'نقل بضائع أم إنقاذ طارئ SOS؟ اختر الخدمة المناسبة لحاجتك بنقرة واحدة.',
  },
  'how.1.title': { fr: 'Décrivez vos marchandises', ar: 'صف بضائعك' },
  'how.1.desc': {
    fr: 'Pour le service Transport, indiquez le type de marchandise que vous souhaitez déplacer. Cette étape permet de mieux cibler les transporteurs adaptés.',
    ar: 'لخدمة النقل، حدّد نوع البضاعة التي تريد نقلها. تساعد هذه الخطوة في استهداف الناقلين المناسبين.',
  },
  'how.2.title': { fr: 'Définissez les adresses', ar: 'حدّد العناوين' },
  'how.2.desc': {
    fr: "Renseignez l'adresse d'enlèvement et de livraison. Pour le service SOS, seule l'adresse de destination est requise.",
    ar: 'أدخل عنوان الاستلام والتسليم. لخدمة SOS، يكفي عنوان الوجهة فقط.',
  },
  'how.3.title': {
    fr: 'Choisissez le véhicule adapté',
    ar: 'اختر المركبة المناسبة',
  },
  'how.3.desc': {
    fr: "Camionnette, camion, plateau… L'application vous recommande le véhicule idéal en fonction de vos marchandises.",
    ar: 'شاحنة صغيرة، شاحنة كبيرة، سطحة… يقترح التطبيق المركبة المثالية بناءً على بضائعك.',
  },
  'how.4.title': { fr: 'Sélectionnez vos transporteurs', ar: 'اختر الناقلين' },
  'how.4.desc': {
    fr: "Parcourez la liste des transporteurs disponibles et sélectionnez-en plusieurs pour maximiser vos chances d'acceptation.",
    ar: 'تصفّح قائمة الناقلين المتاحين واختر عدة ناقلين لزيادة فرص القبول.',
  },
  'how.5.title': { fr: 'Attendez la confirmation', ar: 'انتظر التأكيد' },
  'how.5.desc': {
    fr: "Votre demande est envoyée aux transporteurs choisis. Dès qu'un transporteur accepte, vous êtes notifié instantanément.",
    ar: 'يُرسل طلبك إلى الناقلين المختارين. بمجرد قبول ناقل، تُخطَر فوراً.',
  },
  'how.6.title': { fr: "Coordonnez dans l'app", ar: 'نسّق عبر التطبيق' },
  'how.6.desc': {
    fr: "Échangez avec votre transporteur via le chat intégré ou l'appel vocal pour confirmer les détails de la mission.",
    ar: 'تواصل مع ناقلك عبر الدردشة المدمجة أو الاتصال الصوتي لتأكيد تفاصيل المهمة.',
  },
  'how.7.title': { fr: 'Suivez en temps réel', ar: 'تابع في الوقت الفعلي' },
  'how.7.desc': {
    fr: "Suivez le statut de votre commande par notifications push ou directement dans l'application. Vous êtes informé à chaque étape.",
    ar: 'تابع حالة طلبك عبر الإشعارات الفورية أو مباشرة في التطبيق. تُخطَر عند كل مرحلة.',
  },
  'how.8.title': { fr: 'Évaluez le transporteur', ar: 'قيّم الناقل' },
  'how.8.desc': {
    fr: 'Mission accomplie\u00a0! Notez votre transporteur pour aider la communauté et améliorer vos futures connexions.',
    ar: 'اكتملت المهمة! قيّم ناقلك لمساعدة المجتمع وتحسين تجاربك المستقبلية.',
  },

  // ─── VIDEO SHOWCASE ───
  'video.label': { fr: 'Vidéos', ar: 'الفيديوهات' },
  'video.heading': { fr: "Voyez l'expérience", ar: 'شاهد التجربة' },
  'video.0.title': { fr: 'LinxExpress en action', ar: 'LinxExpress في العمل' },
  'video.0.subtitle': { fr: 'Découvrez la plateforme', ar: 'اكتشف المنصة' },
  'video.1.title': { fr: "L'expérience transporteur", ar: 'تجربة الناقل' },
  'video.1.subtitle': { fr: 'Rejoignez le réseau', ar: 'انضم إلى الشبكة' },
  'video.play': { fr: 'Regarder', ar: 'مشاهدة' },
  'video.close': { fr: 'Fermer', ar: 'إغلاق' },

  // ─── PINNED PANELS ───
  'panels.label': { fr: "L'Application", ar: 'التطبيق' },
  'panels.intro.title': {
    fr: 'Deux apps,\nun écosystème',
    ar: 'تطبيقان،\nمنظومة واحدة',
  },
  'panels.intro.desc': {
    fr: "Une application dédiée pour chaque acteur du transport. Client ou transporteur, l'expérience est conçue pour vous.",
    ar: 'تطبيق مخصص لكل طرف في عملية النقل. سواء كنت عميلاً أو ناقلاً، التجربة مصممة لك.',
  },
  'panels.client.title': { fr: 'Application Client', ar: 'تطبيق العميل' },
  'panels.client.desc': {
    fr: 'Trouvez un transporteur, envoyez votre demande et suivez votre livraison du premier clic à la confirmation.',
    ar: 'ابحث عن ناقل، أرسل طلبك وتتبع توصيلتك من أول نقرة حتى التأكيد.',
  },
  'panels.client.f1': {
    fr: 'Demande en quelques clics',
    ar: 'طلب بنقرات قليلة',
  },
  'panels.client.f2': { fr: 'Suivi GPS en direct', ar: 'تتبع GPS مباشر' },
  'panels.client.f3': { fr: 'Chat intégré', ar: 'محادثة مدمجة' },
  'panels.client.f4': { fr: 'Historique complet', ar: 'سجل كامل' },
  'panels.driver.title': { fr: 'Application Transporteur', ar: 'تطبيق الناقل' },
  'panels.driver.desc': {
    fr: 'Recevez des missions, gérez votre disponibilité et développez votre activité de transport indépendant.',
    ar: 'تلقَّ المهام، أدر توافرك وطوّر نشاطك في النقل المستقل.',
  },
  'panels.driver.f1': {
    fr: 'Alertes missions instantanées',
    ar: 'تنبيهات مهام فورية',
  },
  'panels.driver.f2': { fr: 'Gestion de disponibilité', ar: 'إدارة التوافر' },
  'panels.driver.f3': { fr: 'Tableau de bord revenus', ar: 'لوحة إيرادات' },
  'panels.driver.f4': { fr: 'Système de réputation', ar: 'نظام السمعة' },

  // ─── TESTIMONIALS ───
  'testimonials.label': { fr: 'Témoignages', ar: 'الشهادات' },
  'testimonials.heading': { fr: "Ce qu'ils en disent", ar: 'ماذا يقولون' },
  'testimonials.0.quote': {
    fr: "LinxExpress m'a permis de trouver un transporteur rapidement pour un déménagement urgent. L'interface est claire, le suivi GPS est rassurant.",
    ar: 'مكّنني LinxExpress من إيجاد ناقل بسرعة لنقل عاجل. الواجهة واضحة وتتبع GPS مطمئن.',
  },
  'testimonials.0.role': { fr: 'Client', ar: 'عميل' },
  'testimonials.1.quote': {
    fr: "Depuis que j'utilise l'app, j'ai une bien meilleure visibilité sur les missions. Le système de réputation m'aide à décrocher plus de courses.",
    ar: 'منذ أن بدأت باستخدام التطبيق، أصبح لديّ رؤية أوضح بكثير على المهام. يساعدني نظام السمعة على الحصول على مزيد من الرحلات.',
  },
  'testimonials.1.role': { fr: 'Transporteur', ar: 'ناقل' },
  'testimonials.2.quote': {
    fr: 'Le suivi en temps réel me donne confiance. Je sais exactement où se trouve ma marchandise. Un vrai plus par rapport aux solutions classiques.',
    ar: 'التتبع الفوري يمنحني الثقة. أعرف تماماً أين توجد بضاعتي. ميزة حقيقية مقارنةً بالحلول التقليدية.',
  },
  'testimonials.2.role': { fr: 'Entreprise', ar: 'مؤسسة' },

  // ─── DOWNLOAD CTA ───
  'download.heading': {
    fr: 'Prêt à simplifier vos transports\u00a0?',
    ar: 'هل أنت مستعد لتبسيط نقلك؟',
  },
  'download.subtitle': {
    fr: 'Téléchargez LinxExpress et rejoignez la première plateforme digitale de transport en Tunisie.',
    ar: 'حمّل LinxExpress وانضم إلى أول منصة رقمية للنقل في تونس.',
  },
  'download.googlePlay.label': { fr: 'Disponible sur', ar: 'متاح على' },
  'download.appStore.label': { fr: 'Disponible sur', ar: 'متاح على' },
  'download.clientApp': { fr: 'App Client', ar: 'تطبيق العميل' },
  'download.driverApp': { fr: 'App Transporteur', ar: 'تطبيق الناقل' },

  // ─── FAQ ───
  'faq.label': { fr: 'FAQ', ar: 'الأسئلة الشائعة' },
  'faq.heading': { fr: 'Questions fréquentes', ar: 'الأسئلة المتكررة' },
  'faq.0.q': {
    fr: 'Comment fonctionne LinxExpress ?',
    ar: 'كيف يعمل LinxExpress؟',
  },
  'faq.0.a': {
    fr: 'LinxExpress est une plateforme qui connecte les clients ayant besoin de transport avec des transporteurs indépendants vérifiés. Créez une demande, elle est envoyée aux transporteurs disponibles, le premier à accepter prend la mission. Suivez le transport en temps réel.',
    ar: 'LinxExpress منصة تربط العملاء المحتاجين للنقل بناقلين مستقلين موثّقين. أنشئ طلباً، يُرسل إلى الناقلين المتاحين، أول من يقبل يأخذ المهمة. تابع النقل في الوقت الفعلي.',
  },
  'faq.1.q': {
    fr: 'Comment sont vérifiés les transporteurs ?',
    ar: 'كيف يتم التحقق من الناقلين؟',
  },
  'faq.1.a': {
    fr: "Chaque transporteur passe un processus complet : vérification d'identité (CIN), permis de conduire, carte grise, photos du véhicule, et validation par entretien.",
    ar: 'يمر كل ناقل بعملية شاملة: التحقق من الهوية (CIN)، رخصة القيادة، بطاقة المركبة، صور السيارة، والتحقق عبر مقابلة.',
  },
  'faq.2.q': {
    fr: 'Quels types de marchandises puis-je transporter ?',
    ar: 'ما أنواع البضائع التي يمكن نقلها؟',
  },
  'faq.2.a': {
    fr: 'Meubles, matériaux de construction, matériel agricole, produits alimentaires et services de remorquage/SOS. Le transport de marchandises interdites est strictement interdit.',
    ar: 'الأثاث، مواد البناء، المعدات الزراعية، المنتجات الغذائية وخدمات السحب/SOS. نقل البضائع المحظورة ممنوع منعاً باتاً.',
  },
  'faq.3.q': { fr: 'Comment se fait le paiement ?', ar: 'كيف يتم الدفع؟' },
  'faq.3.a': {
    fr: "Le paiement se fait directement entre le client et le transporteur. LinxExpress fonctionne avec un système de commission que les transporteurs règlent via les moyens de recharge disponibles dans l'application.",
    ar: 'يتم الدفع مباشرةً بين العميل والناقل. يعمل LinxExpress بنظام عمولة يسدّدها الناقلون عبر وسائل الشحن المتاحة في التطبيق.',
  },
  'faq.4.q': {
    fr: "L'application couvre-t-elle toute la Tunisie ?",
    ar: 'هل يغطي التطبيق تونس بأكملها؟',
  },
  'faq.4.a': {
    fr: "Oui, de Bizerte au nord à Médenine au sud. Notre réseau de transporteurs continue de s'étendre pour couvrir l'ensemble du territoire.",
    ar: 'نعم، من بنزرت شمالاً إلى مدنين جنوباً. تواصل شبكة الناقلين في التوسع لتغطية كامل التراب التونسي.',
  },
  'faq.5.q': {
    fr: 'Que faire en cas de problème ?',
    ar: 'ماذا أفعل في حالة مشكلة؟',
  },
  'faq.5.a': {
    fr: "Signalez l'incident via l'application. Notre équipe examine chaque cas. Contactez notre support à contact@agodevsolutions.com.",
    ar: 'أبلغ عن الحادثة عبر التطبيق. يراجع فريقنا كل حالة. تواصل مع دعمنا على contact@agodevsolutions.com.',
  },
  'faq.6.q': { fr: 'Comment devenir transporteur ?', ar: 'كيف أصبح ناقلاً؟' },
  'faq.6.a': {
    fr: "Téléchargez l'app transporteur, créez votre compte, soumettez vos documents (CIN, permis, carte grise, photos véhicule). Une fois validés, vous pouvez accepter des missions.",
    ar: 'حمّل تطبيق الناقل، أنشئ حسابك، أرسل وثائقك (CIN، الرخصة، بطاقة المركبة، صور السيارة). بعد التحقق، يمكنك قبول المهام.',
  },
  'faq.notFound': {
    fr: 'Vous ne trouvez pas la réponse ?',
    ar: 'لم تجد الجواب؟',
  },
  'faq.contact': { fr: 'Contactez-nous', ar: 'تواصل معنا' },

  // ─── FOOTER ───
  'footer.tagline': {
    fr: 'La première plateforme digitale de transport en Tunisie. Connecter clients et transporteurs fiables, en toute simplicité.',
    ar: 'أول منصة رقمية للنقل في تونس. ربط العملاء بناقلين موثوقين، ببساطة تامة.',
  },
  'footer.platform': { fr: 'Plateforme', ar: 'المنصة' },
  'footer.features': { fr: 'Fonctionnalités', ar: 'الميزات' },
  'footer.howItWorks': { fr: 'Comment ça marche', ar: 'كيف يعمل' },
  'footer.app': { fr: "L'Application", ar: 'التطبيق' },
  'footer.videos': { fr: 'Vidéos', ar: 'الفيديوهات' },
  'footer.legal': { fr: 'Légal', ar: 'قانوني' },
  'footer.terms': { fr: 'Conditions Générales', ar: 'الشروط العامة' },
  'footer.privacy': { fr: 'Confidentialité', ar: 'الخصوصية' },
  'footer.cookies': { fr: 'Cookies', ar: 'الكوكيز' },
  'footer.refund': { fr: 'Remboursement', ar: 'الاسترداد' },
  'footer.legalNotice': { fr: 'Mentions Légales', ar: 'الإشعارات القانونية' },
  'footer.company': { fr: 'Entreprise', ar: 'الشركة' },
  'footer.reseller': { fr: 'Devenir revendeur', ar: 'كن موزعاً' },
  'footer.faq': { fr: 'FAQ', ar: 'الأسئلة الشائعة' },
  'footer.contact': { fr: 'Contact', ar: 'التواصل' },
  'footer.rights': { fr: 'Tous droits réservés.', ar: 'جميع الحقوق محفوظة.' },
  'footer.cgu': { fr: 'CGU', ar: 'الشروط' },
};

export default translations;
